import React from "react";
import { OverviewContainer, OverviewHighlightText, TermsText } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
import { Note } from "~/components/form/index";
export const DeploymentFreezesOverview = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                Global <ExternalLink href="DeploymentFreezes">Deployment Freezes</ExternalLink> let you temporarily or on a recurring schedule block deployments for multiple projects or tenants to protect critical windows, maintenance periods, or
                business operations.
            </p>
        </OverviewHighlightText>
        <TermsText>
            <Note heading={"Pre-requisites"}>The resources you want to freeze need to be created prior to the creation of the deployment freeze.</Note>
            <Note heading={"Scoping deployment freezes"}>
                Deployment freezes must be scoped to projects and environments or can be scoped to specific tenants if a more granular freeze is required. During deployment, Octopus will block deployments to the frozen resource(s).
            </Note>
            <Note heading={"Permissions"}>
                To create and edit a deployment freeze, the DeploymentFreezeAdminister system permission is required. In addition, permissions will need to be scoped to all requested projects and environments when creating, editing or overriding a
                deployment freeze. The DeploymentFreezeAdminister permission is included in the System Administrator, System Manager and Space Manager roles.
            </Note>
        </TermsText>
    </OverviewContainer>);
